export const authRoles = {
  sa: ["SA"],
  admin: ["SA", "ADMIN", "MEMBRE"],
  editor: ["SA", "ADMIN", "EDITOR"],
  guest: ["SA", "ADMIN", "EDITOR", "GUEST"]
};
